import { ImpactArgs, NotifyArgs } from './types';

export const hapticImpact = (args: ImpactArgs = {}) => {
  // eslint-disable-next-line no-console
  if (__DEV__) {
    // eslint-disable-next-line no-console
    console.log('📳 Haptic Impact', args);
  }
};

export const hapticNotification = (args: NotifyArgs) => {
  // eslint-disable-next-line no-console
  if (__DEV__) {
    // eslint-disable-next-line no-console
    console.log('📳 Haptic Notification', args);
  }
};

export const hapticSelection = () => {
  // eslint-disable-next-line no-console
  if (__DEV__) {
    // eslint-disable-next-line no-console
    console.log('📳 Haptic Selection');
  }
};
